





























































import LoadingSpinner from "./LoadingSpinner.vue";
import TemplateListing from "./TemplateListing.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import jsyaml from "js-yaml";

@Component({
  components: { LoadingSpinner, TemplateListing }
})
export default class TemplatePicker extends Vue {
  loading = false;
  manifestData: { [index: string]: any } = {};
  @Prop({ default: [] })
  manifests!: Array<string[]>;
  codeTypes: any = {};
  codeTypeInput: any = {};
  stepperStep = 1;

  get filteredManifests() {
    return Object.keys(this.manifestData).reduce((acc: any, key: string) => {
      const manifest = this.manifestData[key];
      if ("code_type" in manifest) {
        const platforms = Object.keys(manifest.code_type);
        let added = false;
        for (const platform of platforms) {
          if (this.codeTypeInput.platform === platform) {
            for (const platformType of manifest.code_type[platform]) {
              if (!added && platformType === this.codeTypeInput.type) {
                acc[key] = this.manifestData[key];
                added = true;
              }
            }
          }
        }
      } else {
        acc[key] = this.manifestData[key];
      }
      return acc;
    }, {});
  }

  mounted() {
    this.onMount();
  }

  titlecase(s: string) {
    if (typeof s !== "string") {
      return s;
    }
    return s.substring(0, 1).toLocaleUpperCase() + s.substring(1);
  }

  async onMount() {
    this.loading = true;
    this.manifestData = await this.manifests.reduce(
      async (soFar: any, v: string[]) => {
        soFar = await soFar;
        soFar[v[0]] = jsyaml.load(await (await fetch(v[1])).text());
        return soFar;
      },
      {}
    );

    Object.keys(this.manifestData).forEach((key: any) => {
      const manifest = this.manifestData[key];
      if ("code_type" in manifest) {
        const platforms = Object.keys(manifest.code_type);
        for (const platform of platforms) {
          if (!(platform in this.codeTypes)) {
            this.codeTypes[platform] = {};
          }
          for (const platformType of manifest.code_type[platform]) {
            if (!(platformType in this.codeTypes[platform])) {
              this.codeTypes[platform][platformType] = [];
            }

            this.codeTypes[platform][platformType].push(key);
          }
        }
      }
    });

    this.loading = false;
  }
}
